module.exports = __webpack_public_path__ + "img/nb-logo-christmas.307ba3af.svg";